import apiClient from './client';

export const cryptoApi = {
  getAssets: async (params = {}) => {
    const response = await apiClient.get('/api/crypto/assets', { params });
    return response.data;
  },

  getSnapshots: async (symbols) => {
    const params = {};
    if (Array.isArray(symbols) && symbols.length) params.symbols = symbols.join(',');
    else if (typeof symbols === 'string' && symbols) params.symbols = symbols;
    const response = await apiClient.get('/api/crypto/snapshots', { params });
    return response.data;
  },

  getQuote: async (symbol) => {
    const response = await apiClient.get('/api/crypto/quote', { params: { symbol } });
    return response.data;
  },

  getBars: async (symbol, params = {}) => {
    const response = await apiClient.get('/api/crypto/bars', {
      params: { symbol, ...params },
    });
    return response.data;
  },

  getPositions: async () => {
    const response = await apiClient.get('/api/crypto/positions');
    return response.data;
  },

  closePosition: async (symbol) => {
    const response = await apiClient.post('/api/crypto/positions/close', { symbol });
    return response.data;
  },

  getOrders: async (filters = {}) => {
    const response = await apiClient.get('/api/crypto/orders', { params: filters });
    return response.data;
  },
};
